export default __webpack_public_path__ + "static/media/TheElements _17.fd3ce110.png";